export default __webpack_public_path__ + "static/media/home.cac3dbba.jpg";